<template>
  <div class="item accommodation">
    <div class="date">
      {{ utilDateFlightfox(accommodation.checkin) }}
    </div>
    <div class="provider">
      <div class="col1">
        <div class="icon">&#x1f3e8;</div>
      </div>
      <div class="col2">
        <div class="pri">{{ accommodation.name }} - {{ accommodation.place }}</div>
      </div>
    </div>
    <div class="schedule">
      <div class="col1 path">
        <div class="dot top" />
        <div class="line" />
        <div class="dot bot" />
      </div>
      <div class="col2">
        <div class="avatar">
          <a :href="map" target="_blank">
            <span class="icon">&#x1f4cd;</span>
            <span class="map">Map</span>
          </a>
        </div>
        <div class="timing">
          <div class="row">
            <div class="pri">
              {{ utilTime(accommodation.checkin) }}
            </div>
            <div class="sec">
              {{ utilDateFlightfox(accommodation.checkin) }}
            </div>
          </div>
          <div class="row">
            <div class="pri">
              {{ utilTime(accommodation.checkout) }}
            </div>
            <div class="sec">
              {{ utilDateFlightfox(accommodation.checkout) }}
            </div>
          </div>
        </div>
      </div>
      <div class="col3">
        <div class="row">
          {{ rooms }}
        </div>
        <div class="row">
          {{ utilDurationAccommodationNights(accommodation.checkin, accommodation.checkout, false) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import DateTime from "../../utils/datetime";

const { utilDateFlightfox, utilTime, utilDurationAccommodationNights } = DateTime();

const props = defineProps(["accommodation"]);

const map = computed(() => {
  const query = props.accommodation.name + " " + props.accommodation.place;
  const queryEncoded = query.replace(/ /g, "+");
  return "http://maps.google.com/?q=" + queryEncoded;
});

const rooms = computed(() => {
  return props.accommodation.room_count + " " + (props.accommodation.room_count > 1 ? "Rooms" : "Room");
});
</script>

<style lang="less">
#itineraries {
  .accommodation {
    .avatar {
      a {
        display: block;
        width: 3rem;

        span {
          display: block;
          text-align: center;
        }

        .icon {
          color: @dark;
          font-size: 1.625rem;
          line-height: 1.625rem;
        }

        .map {
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
